import { supabase } from './supabase';

const SHIPPED_STATES = ['shipped', 'delivered', 'completed'];

/**
 * Segna un ordine come spedito: salva tracking e stato, registra lo storico
 * e, solo la prima volta che l'ordine passa a "spedito", manda l'email al
 * cliente. Usata da dashboard e dettaglio ordine, così il flusso è uno solo.
 *
 * Lancia un errore se l'aggiornamento dell'ordine fallisce; un'email non
 * partita non annulla la spedizione ma viene riportata in `emailError`.
 */
export async function shipOrder({
  orderId,
  trackingNumber,
  previousStatus,
  notes,
}: {
  orderId: string;
  trackingNumber: string;
  previousStatus: string;
  notes?: string;
}): Promise<{ emailSent: boolean; emailError: string | null }> {
  const tracking = trackingNumber.trim();
  if (!tracking) throw new Error('Inserisci il numero di tracking');

  const { error: updateError } = await supabase
    .from('orders')
    .update({ status: 'shipped', tracking_number: tracking })
    .eq('id', orderId);
  if (updateError) throw updateError;

  const { error: historyError } = await supabase
    .from('order_status_history')
    .insert({ order_id: orderId, status: 'shipped', notes });
  if (historyError) console.error('Error writing order status history:', historyError);

  // Se l'admin corregge il tracking di un ordine già spedito non rimandiamo
  // l'email.
  if (SHIPPED_STATES.includes(previousStatus)) {
    return { emailSent: false, emailError: null };
  }

  const { error: emailError } = await supabase.functions.invoke('send-shipping-notification', {
    // Destinatario e nome li legge la funzione dall'ordine nel DB.
    body: { orderId, trackingNumber: tracking },
  });

  if (emailError) {
    let message = '';
    try {
      message = (await emailError.context?.json())?.error ?? '';
    } catch {
      // corpo non JSON
    }
    console.error('Error sending shipping notification email:', emailError, message);
    return { emailSent: false, emailError: message || 'Invio email non riuscito' };
  }

  return { emailSent: true, emailError: null };
}
